import React, { Fragment, PureComponent, useState, useEffect, useContext, useReducer, useMemo, useCallback } from 'react';
import { merge, clone, get, remove, pullAt, concat } from 'lodash';
import { Button, List, Modal, Icon, Switch, InputItem, TextareaItem, Toast, Carousel } from 'antd-mobile';
import { Vh5Bar } from '../../../components/bar';
export function EditSingleImg(props) {
	let { files, index = 0, backCallback, saveCallback } = props;
	let [carouselIndex, setCarouselIndex] = useState(index);
	let [values, setValues] = useState(() => {
		let obj = {};
		for (let i = 0, j = files.length; i < j; i++) {
			let curValue = files[i].textArea;
			obj[i] = curValue;
		}
		return obj;
	});
	let barConfig = {
		backCallback,
		barContentText: carouselIndex + 1 + '/' + files.length,
		saveCallback: () => {
			for (let o in values) {
				files[o]['textArea'] = values[o];
			}
			saveCallback(files);
			backCallback();
		},
		barRightText: '确定'
	};
	function handleDesChange(value) {
		console.log('@B', value, carouselIndex);
		values[carouselIndex] = value;
		setValues(clone(values));
	}
	return (
		<div className="edit-dialog-wrap">
			<Vh5Bar {...barConfig} />
			<Carousel
				autoplay={false}
				infinite
				dots={true}
				selectedIndex={index}
				beforeChange={(from, to) => {
					console.log(`slide from ${from} to ${to}`);
				}}
				afterChange={index => {
					setCarouselIndex(index);
				}}>
				{get(files, 'length', 0) &&
					files &&
					files.map((item, index) => {
						return (
							<div className="upload-eidtimg-wrap" key={'edit-img-' + index}>
								<img alt="" src={item.url} height="250px" />
							</div>
						);
					})}
			</Carousel>
			<div className="textarea-wrap">
				<TextareaItem
					className="textarea-img"
					value={values[carouselIndex]}
					placeholder="请描述创作背景、故事、或思考…"
					prefixListCls="photo-des"
					onChange={handleDesChange}
					onBlur={() => {
						setTimeout(() => {
							window.scrollTo(0, 0);
						}, 0);
					}}
					maxLength={140}
				/>
				<div className="textarea-len">{get(values[carouselIndex], 'length', '0')}/140</div>
			</div>
		</div>
	);
}
